import i18n from '~/translations';

export const CANCEL_REASONS = [
  'not_enough_time_to_use',
  'too_high_price',
  'too_difficult_to_use',
  'found_better_tool',
  'missing_features',
  'too_many_bugs',
  'project_ended',
  'lack_of_community',
  'poor_customer_service',
  'other',
] as const;

export type CancelReason = (typeof CANCEL_REASONS)[number];

export const CANCEL_REASON_LABEL: Record<CancelReason, string> = {
  not_enough_time_to_use: i18n.t(
    'cancelReason.notEnoughTimeToUse',
    "I didn't have time to use BugBug",
  ),
  too_high_price: i18n.t('cancelReason.tooHighPrice', 'Price is too high'),
  too_difficult_to_use: i18n.t('cancelReason.tooDifficultToUse', 'Too difficult to use'),
  found_better_tool: i18n.t('cancelReason.foundBetterTool', 'Found a better tool'),
  missing_features: i18n.t('cancelReason.missingFeatures', 'Missing features'),
  too_many_bugs: i18n.t('cancelReason.tooManyBugs', 'Too many bugs'),
  project_ended: i18n.t('cancelReason.projectEnded', 'Project ended'),
  lack_of_community: i18n.t('cancelReason.lackOfCommunity', 'Lack of community'),
  poor_customer_service: i18n.t('cancelReason.poorCustomerService', 'Poor customer service'),
  other: i18n.t('cancelReason.other', 'Other'),
};
